// UtilityButton.tsx
import React from 'react';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import { UtilityButtonProps } from 'types/UtilityButtonProps';

const SecondaryButton: React.FC<UtilityButtonProps> = ({
  label,
  size,
  onClick,
  disabled = false,
  type = 'button',
  className,
}) => {
  return (
    <Button
      className={`text-dark bg-white ${className}`}
      variant="secondary"
      size={size}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {label}
    </Button>
  );
};

export default SecondaryButton;
